import { usePageTitle } from '@hooks/useTitle'
import { createVariants } from 'shared-ui/lib'

export enum TabPageTheme {
  Dark = 'dark',
  Light = 'light'
}

type TabPageProps = {
  children: React.ReactNode
  title: string
  preTitle?: string
  /** Names the page in the browser tab when the heading is a greeting or phrase rather than a page name. */
  tabTitle?: string
  theme?: TabPageTheme
}

const bannerClasses = createVariants({
  slots: {
    banner: 'w-full',
    preTitle: '',
    title: 'pan-billboard print:hidden'
  },
  variants: {
    theme: {
      dark: {
        banner: 'bg-gray-900',
        preTitle: 'pan-label-wide text-green-300 print:text-green-500',
        title: 'text-white'
      },
      light: {
        banner: 'bg-white',
        preTitle: 'pan-title5 uppercase text-gray-500',
        title: 'text-gray-900'
      }
    }
  },
  defaultVariants: {
    theme: TabPageTheme.Dark
  }
})

/** Page frame with a heading banner. The title also names the page in the browser tab. */
export const TabPage: React.FC<TabPageProps> = ({ children, title, preTitle, tabTitle, theme }) => {
  usePageTitle(tabTitle ?? title)
  const classes = bannerClasses({ theme })

  return (
    <main>
      <div className={classes.banner()}>
        <div className="relative mx-auto px-6 py-6 xl:w-[1328px] 2xl:w-[1480px]">
          <p className={classes.preTitle()}>{preTitle}</p>
          <h1 className={classes.title()}>{title}</h1>
        </div>
      </div>
      <div className="relative mx-auto px-6 py-6 lg:py-12 xl:w-[1328px] 2xl:w-[1480px]">
        {children}
      </div>
    </main>
  )
}
